import { useQuery } from '@tanstack/react-query';
import { n8nFetch } from '../n8nClient';
import type { Empresa } from '../types';

export interface EmpresasFilter {
  setor?: string;
  cidade?: string;
  status_funil?: string;
  prioridade?: string;
  tag?: string;
  q?: string;
  tem_telefone?: boolean;
  tem_site?: boolean;
  tem_redes?: boolean;
  situacao_ativa?: boolean;
  score_min?: number;
  porte?: string;
  cnae?: string;
  enriquecida?: boolean;
  order?: 'score' | 'prioridade' | 'recente' | 'nome';
  limit?: number;
  offset?: number;
}

export function useEmpresas(filter: EmpresasFilter = {}) {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filter)) {
    if (v === undefined || v === null || v === '' || v === false) continue;
    params.set(k, String(v));
  }
  const qs = params.toString();
  return useQuery({
    queryKey: ['empresas', filter],
    queryFn: () => n8nFetch<Empresa[]>(`/empresas${qs ? `?${qs}` : ''}`),
  });
}
